import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { money } from '../config/brand.js';

export default function ThankYou() {
  const { state } = useLocation();
  const order = state && state.order;
  return (
    <div className="page page--narrow center">
      <p className="eyebrow">Order placed</p>
      <h1 className="page__title">Thank you{order ? `, ${order.customerName.split(' ')[0]}` : ''}</h1>
      {order ? (
        <>
          <p className="muted">Your order number is <strong>{order.id}</strong>. We will contact you to confirm before dispatch. A confirmation has been sent to {order.customerEmail}.</p>
          <div className="receipt">
            {order.items.map((i) => (
              <div key={`${i.id}-${i.size}`} className="sum"><span>{i.name}{i.size ? ` (${i.size})` : ''} x {i.quantity}</span><span>{money(i.price * i.quantity)}</span></div>
            ))}
            <div className="sum sum--muted"><span>Shipping</span><span>{order.shipping ? money(order.shipping) : 'Free'}</span></div>
            <div className="sum sum--total"><span>Total to pay on delivery</span><span>{money(order.total)}</span></div>
          </div>
        </>
      ) : <p className="muted">We have received your order.</p>}
      <Link to="/shop" className="btn">Continue shopping</Link>
    </div>
  );
}
